module.exports = __webpack_public_path__ + "img/AYURVEDICO.08de9684.png";